import { render } from "./BotaoAcoes.vue?vue&type=template&id=8fde4642&ts=true"
import script from "./BotaoAcoes.vue?vue&type=script&lang=ts"
export * from "./BotaoAcoes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Botoes/BotaoAcoes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8fde4642"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8fde4642', __exports__)) {
    api.reload('8fde4642', __exports__)
  }
  
  module.hot.accept("./BotaoAcoes.vue?vue&type=template&id=8fde4642&ts=true", () => {
    api.rerender('8fde4642', render)
  })

}


export default __exports__